/* esm.sh - applesauce-common@5.2.0/dist/models/shares */
export * from "/*applesauce-common@5.2.0/esnext/dist/models/shares.mjs";
